var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getErrorMessage } from '../utils';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let globalConfig = {};
let reloadConfigFunction = undefined;
export function getConfig() {
    return globalConfig;
}
export function resetConfig() {
    globalConfig = {};
    return globalConfig;
}
export function reloadConfig() {
    if (reloadConfigFunction) {
        return reloadConfigFunction === null || reloadConfigFunction === void 0 ? void 0 : reloadConfigFunction();
    }
    else {
        return Promise.resolve();
    }
}
function combineErrors(params) {
    let message = '';
    params.forEach((param) => {
        if (param.error) {
            message += getErrorMessage(param.error);
        }
    });
    return message;
}
function combineData(params, namespace) {
    if (namespace && !globalConfig[namespace]) {
        globalConfig[namespace] = {};
    }
    params.forEach((param) => {
        if (param.data) {
            if (param.key && namespace) {
                globalConfig[namespace][param.key] = Object.assign(Object.assign({}, globalConfig[namespace]), param.data);
            }
            else if (!param.key && namespace) {
                globalConfig[namespace] = Object.assign(Object.assign({}, globalConfig[namespace]), param.data);
            }
            else if (param.key && !namespace) {
                globalConfig[param.key] = Object.assign({}, param.data);
            }
            else {
                globalConfig = Object.assign(Object.assign({}, globalConfig), param.data);
            }
        }
    });
    return useConfig;
}
export function useConfig(params, namespace, finalConfig) {
    const errors = combineErrors(params);
    const isLoading = params.some((param) => param.isLoading);
    const reload = () => __awaiter(this, void 0, void 0, function* () {
        yield Promise.all(params.map((param) => {
            if (param.reload) {
                return param.reload();
            }
        }));
    });
    if (finalConfig) {
        reloadConfigFunction = () => reload();
    }
    if (params.length < 1) {
        throw new Error('At least one config is required');
    }
    return {
        data: combineData(params, namespace),
        isLoading: isLoading,
        error: errors ? new Error(errors) : undefined,
        reload,
    };
}
